<!--child.vue-->
<template>
  <div class="tips_wrap">
    <el-dialog :close-on-click-modal="false" title="用户" :visible.sync="dialogFormVisible" @close="closeDialog">
      <el-form v-loading="loading" :model="ruleForm"  ref="ruleForm" label-width="50rpx"
        class="demo-ruleForm">
        <el-form-item label="姓名">
          <el-input v-model="ruleForm.nickName"></el-input>
        </el-form-item>
        <el-form-item label="手机号" >
          <el-input v-model="ruleForm.phone"></el-input>
        </el-form-item>



        <el-form-item label="余额">
          <el-input v-model="ruleForm.money"></el-input>
        </el-form-item>

        <el-form-item label="地址" prop="name">
          <el-input v-model="ruleForm.city"></el-input>
        </el-form-item>


        <el-form-item>
          <div style="text-align: right;"> <el-button type="primary" @click="submitForm()">保存</el-button></div>
         
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
export default {

  props: {
    dialogShow: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    console.log("我是子组件");
  },

  data() {
    return {
      loading: false,
      ruleForm: {
        status:'0',
        id: "",
        nickName: "",
        phone: "",
        city: "",
        money: ""
      },
      dialogFormVisible: this.dialogShow,
    }
  },
  created() {
    
  },
  watch: {
    dialogShow(val) {
      this.dialogFormVisible = val
    },
  },
  methods: {

    init(id) {
      var that = this;
      that.loading = true
      this.$axios.post("/api2/user/findOneUser/" , {
        id
      })
        .then(function (response) {
          console.log(response.data);
          if (response.data.code == 200) {
            console.log(response.data.data)
            that.ruleForm = response.data.data
          } else {
            that.$message.error(response.mes);
          }
          that.loading = false
        })
    },
    submitForm() {
      var that = this;
     
      this.$axios.post("/api2/user/registerByAdmin", that.ruleForm)
        .then(function (response) {
          console.log(response.data);
          if (response.data.code == 200) {
            that.$message({
              type: 'success',
              message: "操作成功"
            });
            that.$emit('pushdata')
            that.closeDialog()
          } else {
            that.$message.error(response.data.mes);
          }
        })
    },

  
    closeDialog() {
      this.$emit('modelChange', false)
    },


  }
}
</script>

